// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-workbook-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--dl-color-base-workbook-icon);
  text-transform: uppercase;
}
.dl-workbook-icon__letters {
  text-align: center;
  color: var(--dl-color-text-workbook-icon);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/WorkbookIcon/WorkbookIcon.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oDAAA;EACA,yBAAA;AACJ;AACI;EACI,kBAAA;EACA,yCAAA;AACR","sourcesContent":[".dl-workbook-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--dl-color-base-workbook-icon);\n  text-transform: uppercase;\n}\n.dl-workbook-icon__letters {\n  text-align: center;\n  color: var(--dl-color-text-workbook-icon);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
